import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';

@Injectable()
export class AdmManageExceptionCalenderService {

  constructor(private _httpClient: IesHttpClient) {
  }

  getYears(urlParams: any) {
    return this._httpClient.get(AppUrl.getYears, urlParams);
  }

  getData(urlParams: any) {
    return this._httpClient.get(AppUrl.getExceptionCalendarData, urlParams);
  }

  addData(urlParams: any) {
    return this._httpClient.post(AppUrl.addExceptionCalendar, urlParams);
  }

  removeData(urlParams: any) {
    return this._httpClient.post(AppUrl.removeExceptionCalendar, urlParams);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-exception-calender/adm-manage-exception-calender.service.ts